module.exports = "https://cdn-skillquest.mathletics.com/app/174/assets/images/4f6c1126d3155b37e0e493b37624536e.svg";